export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const SET_SHOULD_REFRESH = "SET_SHOULD_REFRESH";
export const SET_SETTINGS_ID = "SET_SETTINGS_ID";
export const SWITCH_IS_SAVING = "SWITCH_IS_SAVING";



// WEBPACK FOOTER //
// ./src/store/settings/mutations.js